export default __webpack_public_path__ + "static/the singing mermaid with stars wide-09c28d56ae1f5fc168ee2d809afc70c0.png";